import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { useParams } from 'react-router';
import TableLightBackground from '../../../Components/TableLightBackground/TableLightBackground';
import { SearchBar } from '../../../molecules';
import AddGlossary from './AddGlossary';
import { useDeleteGlossaryRecordMutation, useDeleteWikiGlossaryImageMutation, useGetWikiGlossaryQuery } from '../../../redux/rtkQuery/apiWikiGlossarySlice';
import { RootState } from '../../../redux/root';
import { setAddGlossaryOpen, setPreviewImage, setSelectedGlossary } from '../../../redux/slices/wikiSlice';
import { GlossaryDataType } from '../../../api/jurisdiction';
import { DONTSEARCH } from '../../../pages/Reports/DailyInspectionReport/InspectionEditor/constants';

const WikiGlossary = () => {
  const [search, setSearch] = useState<string>(DONTSEARCH);
  const { data } = useGetWikiGlossaryQuery(search, { skip: search === "" });
  const [rows, setRows] = useState([]);
  const { previewImage, selectedGlossary } = useSelector((s: RootState) => s.wikiSlice);
  const [deleteWikiGlossaryImage] = useDeleteWikiGlossaryImageMutation();
  const [deleteGlossaryRecord] = useDeleteGlossaryRecordMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      setRows(data.results);
    }
  }, [data]);

  const headers = [
    { title: 'Name', key: 'name' },
    { title: 'Definition', key: 'definition', allowLinks: true },
    { title: 'Sample Pictures', key: 'images', imagesArray: true },
  ];

  const onPreview = url => {
    dispatch(setPreviewImage(url));
  };

  const onImageDelete = async ids => {
    await deleteWikiGlossaryImage(ids);
  };

  const onEditGlossary = row => {
    dispatch(setAddGlossaryOpen(true));
    dispatch(setSelectedGlossary(row));
  };

  const onChange = e => {
    if (e === "") {
      setSearch(DONTSEARCH);
      return;
    }
    setSearch(e);
  };

  const onCancel = () => {
    dispatch(setSelectedGlossary({} as GlossaryDataType));
  };

  const onOK = async () => {
    await deleteGlossaryRecord(selectedGlossary);
    dispatch(setSelectedGlossary({} as GlossaryDataType));
  };
  return (
    <Wrapper>
      <AddGlossary onSearchChanged={onChange} />
      <Toolbar>
        <SearchBar onChange={onChange} />
      </Toolbar>
      {previewImage && (
        <Preview>
          <IconWrapper onClick={() => dispatch(setPreviewImage(''))}>
            <CloseIcon />
          </IconWrapper>
          <img src={previewImage} />
        </Preview>
      )}
      <TableLightBackground
        onEdit={onEditGlossary}
        onImageDeleted={onImageDelete}
        onPreview={onPreview}
        rowsTemplate="300px 1fr 255px"
        headers={headers}
        rows={rows}
        deleteConfirmation="Are you sure you want to delete the Glossary Record?"
        onOK={onOK}
        onCancel={onCancel}
      />
    </Wrapper>
  );
};

export default WikiGlossary;

const Preview = styled.div`
  width: 50%;
  padding-top: 3px;
  padding-bottom: 3px;
  background-color: black;
  position: fixed;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 99%;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 11px;
  top: 14px;
  z-index: 3;
  border-radius: 50%;
  border: 2px solid;
  height: 28px;
  background-color: #fff;
  cursor: pointer;
  color: #000;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 24px;
  margin: 0 0 16px;
  padding: 16px 20px;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);

  > div {
    flex: 1;
    max-width: 320px;
  }
`;
